import React, { useMemo } from 'react';

import {
  BannerWarning,
  LocaleSelection,
  HomeCustomisation,
  ServiceCardButton,
} from '@fingermarkglobal/cringer.components';

import DineInImage from '../../../assets/images/dinein.svg';
import TakeawayImage from '../../../assets/images/takeaway.svg';
import WashHandsImage from '../../../assets/images/wash-hands.png';
import DefaultBackgroundImage from '../../../assets/images/BG.png';

const PrimaryHome = ({
  t = () => {},
  className = '',
  languages = [],
  healthMsg = true,
  isCurrentLang,
  primaryAction,
  secondaryAction,
  onChangeLanguage = () => {},
  showTermsAndConditionsButton = false,
  setShowTermsAndConditionsModal = () => {},
}) => {
  const buttonsClass = useMemo(() => {
    return isCurrentLang('vnm') ? 'text-5xl' : 'text-6xl';
  }, [isCurrentLang]);

  return (
    <HomeCustomisation.Provider
      fallback={{
        background: {
          image: DefaultBackgroundImage,
        },
      }}
    >
      <HomeCustomisation.Background />

      <div
        data-test="primary-home"
        className={`z-10 flex flex-col justify-between items-center h-full w-full overflow-y-hidden ${className}`}
      >
        <div
          data-test="home-upper"
          className="flex flex-col items-center justify-start w-full h-full mb-2"
        >
          <div className={`flex flex-col items-center justify-center mt-20 leading-none`}>
            <p className={`text-12xl text-black font-extrabold`} data-test="home-title">
              {t('homeTitle')}
            </p>

            <p className={`text-9xl text-black font-extrabold`} data-test="home-subtitle">
              {t('homeSubtitle')}
            </p>
          </div>
        </div>

        <div
          data-test="home-lower"
          className="flex flex-col-reverse items-center justify-start w-full h-full"
        >
          {showTermsAndConditionsButton && (
            <BannerWarning
              t={t}
              width="109"
              className="w-4/5 mb-2"
              data-test="banner-terms"
              title={t('homeTermsAndConditionsBannerWarningTitle')}
              description={t('homeTermsAndConditionsBannerWarningDescription')}
              additionalDescription={t('homeTermsAndConditionsBannerWarningAdditionalDescription')}
              additionalDescriptionAction={() => setShowTermsAndConditionsModal(true)}
            />
          )}

          {healthMsg && (
            <BannerWarning
              data-test="banner-health"
              t={t}
              width="109"
              image={WashHandsImage}
              className="w-4/5 mb-2"
            />
          )}

          <div
            data-test="home-services"
            className="flex items-stretch justify-center w-4/5 mb-20 space-x-16"
          >
            <ServiceCardButton
              data-test="button-secondary"
              className="bg-white shadow-lg w-home-button h-home-button rounded-home-button pt-0 pb-6"
              onClick={secondaryAction}
            >
              <div className={`mt-4 ${buttonsClass}`}>{t('homeSecondaryAction')}</div>
              <DineInImage className="w-48 h-48" />
            </ServiceCardButton>

            <ServiceCardButton
              data-test="button-primary"
              className="bg-white shadow-lg w-home-button h-home-button rounded-home-button pt-0 pb-6"
              onClick={primaryAction}
            >
              <div className={`mt-4 ${buttonsClass}`}>{t('homePrimaryAction')}</div>
              <TakeawayImage className="w-48 h-48" />
            </ServiceCardButton>
          </div>
        </div>

        <div className="flex justify-center w-full mt-8 mb-8" data-test="home-footer">
          <LocaleSelection
            languages={languages}
            showDivider={true}
            onChangeLanguage={onChangeLanguage}
          />
        </div>
      </div>
    </HomeCustomisation.Provider>
  );
};

export { PrimaryHome };
